// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Close: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <polygon
                fill="currentColor"
                points="14.25 2.25 15 1.5 13.5 .004 12.75 .754 7.5 6.004 2.25 .75 1.5 0 .004 1.5 .754 2.25 6.004 7.5 .75 12.75 0 13.5 1.5 14.996 2.25 14.246 7.5 8.996 12.75 14.25 13.5 15 14.996 13.5 14.246 12.75 8.996 7.5"
            />
        </svg>
    );
};

export default React.memo(Close);
